export default __webpack_public_path__ + "static/media/Mask Group (1).9201a728.png";